module.exports = "<div class=\"prime-project-view\">\n  <shared-project-view project=\"$ctrl.project\"></shared-project-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/admin/project-details/views/prime-project-view/prime-project-view.html
// module id = 952
// module chunks = 0